<!-- Main form of plan's creation -->
<form nestableForm data-testid="planStartWindow">

    <div *ngIf="!isShowClose" [height]="20"></div>

    <!-- Setup block -->
    <div #setupBlock class="cnt-column-centered">

        <!-- Set up block -->
        <div class="pane" [style.width]="parent.renderForSignup && isCrunchChosen ? '100%' : '600px'" [ngClass]="{'box-shadow': !isRenderForSignUp}">

            <!-- Header new plan block -->
            <div class="cnt-row">
                <div [height]="20"></div>
                <div class="filler"></div>
                <div class="h1Font o1Color" style="text-align: center" i18n>{{ 'START_YOUR_PLAN' | translate }}{{isCrunchChosen ? ' from Crunch' : ''}}</div>
                <div class="filler"></div>
                <close-btn *ngIf="isShowClose || (!parent.renderForSignup && isCrunchChosen)" [testId]="'planStartWindowCloseBtn'" (click)="isCrunchChosen ? brixxChosen() : onClose()"></close-btn>
                <div [width]="10"></div>
            </div>

            <!-- Dialog aria chosen-->
            <div class="dialog-area-inner">

                <!-- Basic plan chosen -->
                <ng-template [ngIf]="!isXeroChosen">

                    <div [height]="20"></div>

                    <!-- Switch template block -->
                    <ng-container *ngIf="!isCrunchChosen">
                        <div class="cnt-column-centered">
                            <div class="block">
                                <infoPopUp [pFieldID]="'dPlanSettingsPlanTemplate'" [logoText]="planTemplateLogoText | translate" (infoOpened)="closeOtherInfoPanels($event)" [dCreator]="parent.getDialogCreator()"></infoPopUp>
                                <div [height]="10"></div>

                                <div class="row stretch">
                                    <div #templatesBlock data-testid="switchTemplateBtn" (mouseenter)="templateHover()" (mouseleave)="templateFocusout()" (click)="switchTemplate()" class="plan-template-box">
                                        <div #planTemplateLogoBlock class="plan-template-logo" [ngClass]="teamplatelogoImg" style="margin-left: 20px"></div>
                                        <div [height]="10"></div>
                                        <div #chosenTemplateBlock class="h3Font b1Color chosen-template-margin">{{ chosenTemplateName | translate }}</div>
                                        <div #switchTemplateBlock class="h3Font switch-template" i18n>{{ 'SWITCH_TEMPLATE' | translate }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div [height]="26"></div>
                    </ng-container>

                    <!-- Plan setting block for crunch -->
                    <div [ngClass]="{hiddenCls: isCrunchChosen && !isCrunchConnectionActive}">

                        <!-- Plan name block -->
                        <div [ngClass]="{'cnt-column-centered': !isCrunchChosen, 'cnt-column': isCrunchChosen}">
                            <div class="block">
                                <infoPopUp [pFieldID]="'PlanSettingsPlanName'"
                                           [logoText]="isCrunchChosen ? ( planNameLogoTextCrunchChosen | translate ) : ( planNameLogoText | translate )"
                                           (infoOpened)="closeOtherInfoPanels($event)"
                                           [dCreator]="parent.getDialogCreator()">
                                </infoPopUp>
                                <div [height]="3"></div>
                                <div class="row stretch">
                                    <img-text [hint]="'MY_BUSINESS_PLAN'"
                                              i18n-hint
                                              name="newPlanName"
                                              [(ngModel)]="newPlan.planName"
                                              [backgroundColor]="'white'"
                                              (ngModelChange)="onInputTextChange($event)"
                                              label=""
                                              [height]="40"
                                              [width]="360"
                                              [fieldClass]="'large-field'"
                                              [maxlen]="100"
                                              [testId]="'edPlanName'"></img-text>
                                </div>
                                <div [height]="5"></div>
                                <div [ngClass]="{ 'warning-text': errorMessage }" [height]="13" data-testid="newPlanErrorMessage">{{ errorMessage }}</div>
                            </div>
                            <div *ngIf="isCrunchChosen" class="line g4Background"></div>
                        </div>

                        <div [height]="24"></div>

                        <!-- Choose plan start date and length block -->
                        <div [ngClass]="{'cnt-column-centered': !isCrunchChosen, 'cnt-column': isCrunchChosen}">
                            <div class="block" [style.margin-left.px]="4">
                                <infoPopUp [pFieldID]="'StartDateAndLength'"
                                           [logoText]="isCrunchChosen ? (planStartDateLogoTextCrunchChosen | translate) : ( planStartDateLogoText | translate )"
                                           (infoOpened)="closeOtherInfoPanels($event)"
                                           [dCreator]="parent.getDialogCreator()"></infoPopUp>
                                <div [height]="3"></div>
                                <div class="row stretch">
                                    <div class="cnt-row-centered">

                                        <!-- Month combo -->
                                        <combo hint=""
                                               name="edStartMonth"
                                               [hasOutline]="true"
                                               [backgroundColor]="'white'"
                                               [ComboData]="monthsComboItems"
                                               [showImg]="false"
                                               [ngModel]="newPlan.planStartStr | callback : getMonth"
                                               label=""
                                               [width]="128"
                                               [height]="30"
                                               [inputTextClass]="'small-field'"
                                               [disabledItemClass]="'disabled-opacity'"
                                               testId="edStartMonth"
                                               (changeCaller)="handleStartDateMonthComboChange($event)"></combo>

                                        <div [width]="5"></div>

                                        <!-- Year combo -->
                                        <div>
                                            <combo hint=""
                                                   name="edYear"
                                                   [hasOutline]="true"
                                                   [backgroundColor]="'white'"
                                                   [ComboData]="yearComboItems"
                                                   [showImg]="false"
                                                   [ngModel]="newPlan.planStartStr | callback : getYearId"
                                                   label=""
                                                   [width]="85"
                                                   [height]="30"
                                                   [inputTextClass]="'small-field'"
                                                   (changeCaller)="handleStartDateYearComboChange($event)"
                                                   testId="edYear"></combo>
                                        </div>

                                        <div *ngIf="isCrunchChosen" [width]="55"></div>
                                        <div [width]="5"></div>
                                        <span class="p2Font" i18n>{{ 'FOR' | translate }}</span>
                                        <div [width]="5"></div>

                                        <!-- Duration combo -->
                                        <combo hint=""
                                               name="edDuration"
                                               [hasOutline]="true"
                                               [backgroundColor]="'white'"
                                               [ComboData]="years"
                                               [showImg]="false"
                                               [(ngModel)]="durationYear"
                                               label=""
                                               [width]="115"
                                               [height]="30"
                                               [inputTextClass]="'small-field'"
                                               [disabledItemClass]="'disabled-opacity'"
                                               (changeCaller)="onStartPlanDataChange()"
                                               testId="newPlanDuration"></combo>

                                    </div>
                                </div>

                                <div [height]="26"></div>
                            </div>
                            <div *ngIf="isCrunchChosen" class="line g4Background"></div>
                        </div>

                        <!-- Currency + Tax block -->
                        <div [ngClass]="{'cnt-column-centered': !isCrunchChosen, 'cnt-column': isCrunchChosen}">
                            <div class="cnt-row">

                                <!-- Currency block -->
                                <ng-container *ngIf="!isCrunchChosen">
                                    <div class="block">
                                        <div [height]="23"></div>
                                        <infoPopUp [pFieldID]="'PlanSettingsCurrency'" [logoText]="currencyLogoText | translate" (infoOpened)="closeOtherInfoPanels($event)" [dCreator]="parent.getDialogCreator()"></infoPopUp>
                                        <div [height]="3"></div>

                                        <div class="row">
                                            <combo hint=""
                                                   name="edCurrencySymbol"
                                                   [hasOutline]="true"
                                                   [backgroundColor]="'white'"
                                                   [ComboData]="currencyItems"
                                                   [showImg]="false"
                                                   [(ngModel)]="currencyString"
                                                   label=""
                                                   [width]="128"
                                                   [height]="30"
                                                   [inputTextClass]="'small-field'"
                                                   testId="edCurrencySymbol"></combo>
                                        </div>
                                    </div>
                                </ng-container>

                                <div [width]="55" *ngIf="!isCrunchChosen"></div>

                                <!-- Tax block -->
                                <div class="block">
                                    <div [height]="22"></div>
                                    <infoPopUp [pFieldID]="'VatTaxSystem'"
                                               [logoText]="isCrunchChosen ? ( taxSystemLogoTextCrunchChosen | translate ) : ( taxSystemLogoText | translate )"
                                               (infoOpened)="closeOtherInfoPanels($event)"
                                               [dCreator]="parent.getDialogCreator()">
                                    </infoPopUp>
                                    <div [height]="3"></div>
                                    <div class="tax-row">
                                        <div class="row">
                                            <combo hint=""
                                                   name="edVatCalcOption"
                                                   [hasOutline]="true"
                                                   [backgroundColor]="'white'"
                                                   [ComboData]="onOrOffByDefault"
                                                   [showImg]="false"
                                                   [(ngModel)]="aVatText"
                                                   label=""
                                                   [width]="113"
                                                   [height]="30"
                                                   [inputTextClass]="'small-field'"
                                                   [disabled]="isFreeLicense"
                                                   testId="edVatCalcOption">
                                            </combo>
                                        </div>
                                    </div>
                                    <div [height]="29"></div>
                                </div>
                            </div>
                            <div *ngIf="isCrunchChosen" class="line g4Background"></div>
                        </div>

                        <!-- Forecast for crunch block -->
                        <ng-container *ngIf="isCrunchChosen">
                            <div [height]="24"></div>

                            <!-- Extrapolating for crunch block -->
                            <div class="block cnt-row-centered">
                                <infoPopUp [pFieldID]="'StartCheck'" [logoText]="''" (infoOpened)="closeOtherInfoPanels($event)" [dCreator]="parent.getDialogCreator()"></infoPopUp>
                                <div [height]="5"></div>
                                <slide-switcher name="isFillForecasts" [label]="'Fill your forecast by extrapolating historical data'" [(ngModel)]="data.isFillForecasts" [testId]="'switcher-forecast-div'"></slide-switcher>
                            </div>

                            <!-- Table forecast -->
                            <div class="block">
                                <div #tableDiv [ngClass]="{ hiddenCls: !data.isFillForecasts }" style="width: 100%">
                                    <div [height]="15"></div>
                                    <div class="line g4Background" style="margin-left: 30px; width: auto"></div>

                                    <div [height]="20"></div>

                                    <table class="data-table controlsPadding">
                                        <tr>
                                            <td [width]="200" class="h4Font" i18n>{{ 'CATEGORY' | translate }}</td>
                                            <td [width]="230" class="h4Font" i18n>{{ 'FORECAST_METHOD' | translate }}</td>
                                            <td *ngIf="notAllAdjustsBlank()" [width]="100" class="h4Font" i18n>{{ 'ADJUSTMENT' | translate }}</td>
                                        </tr>
                                        <tr [height]="20"></tr>

                                        <tr>
                                            <td class="p2Font" i18n>{{ 'REVENUE' | translate }}</td>
                                            <td>
                                                <combo #salesCombo
                                                       name="salesValue"
                                                       [ComboData]="comboItems"
                                                       [(ngModel)]="data.salesValue"
                                                       [height]="30"
                                                       [width]="180"
                                                       [label]="''"
                                                       [backgroundColor]="'white'"
                                                       [inputTextClass]="'small-field'"
                                                       [showImg]="false"
                                                       [testId]="'salesCombo'"></combo>
                                            </td>
                                            <td *ngIf="isNotBlank(data.salesValue)">
                                                <img-text name="salesAdjust"
                                                          [showImg]="false"
                                                          [(ngModel)]="data.salesAdjust"
                                                          [getDisplayValue]="getPercentFieldDisplayValue"
                                                          [height]="30"
                                                          [width]="95"
                                                          [backgroundColor]="'white'"
                                                          [valueType]="'number'"
                                                          [minValue]="-1 | minValue"
                                                          [label]="''"
                                                          [testId]="'salesAdjust'"></img-text>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="p2Font" i18n>{{ 'COST_OF_SALES' | translate }}</td>
                                            <td>
                                                <combo #costsCombo
                                                       name="costsValue"
                                                       [ComboData]="comboItems"
                                                       [(ngModel)]="data.costsValue"
                                                       [height]="30"
                                                       [width]="180"
                                                       [label]="''"
                                                       [backgroundColor]="'white'"
                                                       [inputTextClass]="'small-field'"
                                                       [showImg]="false"
                                                       [testId]="'costsCombo'">
                                                </combo>
                                            </td>
                                            <td *ngIf="isNotBlank(data.costsValue)">
                                                <img-text [showImg]="false"
                                                          name="costsAdjust"
                                                          [(ngModel)]="data.costsAdjust"
                                                          [getDisplayValue]="getPercentFieldDisplayValue"
                                                          [height]="30"
                                                          [width]="95"
                                                          [backgroundColor]="'white'"
                                                          [valueType]="'number'"
                                                          [minValue]="-1 | minValue"
                                                          [label]="''"
                                                          [testId]="'costsAdjust'">
                                                </img-text>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="p2Font" i18n>{{ 'SALARIES' | translate }}</td>
                                            <td>
                                                <combo #salariesCombo
                                                       name="salariesValue"
                                                       [ComboData]="comboItems"
                                                       [(ngModel)]="data.salariesValue"
                                                       [height]="30"
                                                       [width]="180"
                                                       [label]="''"
                                                       [backgroundColor]="'white'"
                                                       [inputTextClass]="'small-field'"
                                                       [showImg]="false"
                                                       [testId]="'salariesCombo'">
                                                </combo>
                                            </td>
                                            <td *ngIf="isNotBlank(data.salariesValue)">
                                                <img-text [showImg]="false"
                                                          name="salariesAdjust"
                                                          [(ngModel)]="data.salariesAdjust"
                                                          [getDisplayValue]="getPercentFieldDisplayValue"
                                                          [height]="30"
                                                          [width]="95"
                                                          [backgroundColor]="'white'"
                                                          [valueType]="'number'"
                                                          [minValue]="-1 | minValue"
                                                          [label]="''"
                                                          [testId]="'salariesAdjust'">
                                                </img-text>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="p2Font" i18n>{{ 'OTHER_OPERATING_EXPENSES' | translate }}</td>
                                            <td>
                                                <combo #expensesCombo
                                                       name="startDateMonth"
                                                       [ComboData]="comboItems"
                                                       [(ngModel)]="data.expensesValue"
                                                       [height]="30"
                                                       [width]="180"
                                                       [label]="''"
                                                       [backgroundColor]="'white'"
                                                       [inputTextClass]="'small-field'"
                                                       [showImg]="false"
                                                       [testId]="'expensesCombo'">
                                                </combo>
                                            </td>
                                            <td *ngIf="isNotBlank(data.expensesValue)">
                                                <img-text [showImg]="false"
                                                          name="expensesAdjust"
                                                          [(ngModel)]="data.expensesAdjust"
                                                          [getDisplayValue]="getPercentFieldDisplayValue"
                                                          [height]="30"
                                                          [width]="95"
                                                          [backgroundColor]="'white'"
                                                          [valueType]="'number'"
                                                          [minValue]="-1 | minValue"
                                                          [label]="''"
                                                          [testId]="'expensesAdjust'">
                                                </img-text>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>

                            <div [height]="28"></div>
                            <div class="line g4Background"></div>
                        </ng-container>
                    </div>

                    <!-- Create or Connect to crunch button -->
                    <div class="cnt-column-centered" [style.margin-top.px]="isCrunchChosen ? 20 : 0">
                        <div class="cnt-row" style="align-items: center">
                            <div *ngIf="!isCrunchChosen" 
                                 [ngClass]="{
                                    'brixxLogo-small' : !isBusinessDoctors,
                                    'businessDoctorsLogo-small' : isBusinessDoctors
                                 }" 
                                 class="plan-template-logo"></div>
                            <simple-btn [width]="240"
                                        [text]="isCrunchChosen ? !isCrunchConnectionActive ? ( connectToCrunchButtonText | translate ) : ( createPlanButtonText | translate ) : ( startPlanButtonText | translate )"
                                        [backgroundFillCls]="'o2Background'"
                                        [hoverFillCls]="'o1Background'"
                                        [boxShadowCls]="'primary-shadow'"
                                        (click)="createPlan()"
                                        [textCls]="'large-btn-text-500 m-auto'"
                                        [height]="40"
                                        [fontSize]="'16px'"
                                        [cornerRadius]="50"
                                        [horizontalPadding]="20"
                                        [rightSpace]="5"
                                        data-testid="planStartWindowCreateBtn"
                                        style="margin-left: 20px">
                            </simple-btn>
                        </div>
                    </div>

                    <div class="cnt-column-centered" *ngIf="!isCrunchChosen">
                        <div class="big-separating-line"></div>
                    </div>

                    <!-- Footer block -->
                    <div *ngIf="isBrixxChosen">
                        <div [height]="30" style="text-align: center">
                            <span class="p2Font b4Color" i18n>{{ 'OR_YOU_CAN_START' | translate }}</span>
                        </div>

                        <div [height]="10"></div>

                        <!-- Crunch and Xero buttons -->
                        <div class="cnt-column-centered">
                            <simple-btn #xeroSignUpBtn
                                        [hoverDisabled]="isUpgradeNeeded"
                                        class="integration_button"
                                        [text]="isUpgradeNeeded ? ( xeroUpgradeButtonText | translate ) : ( xeroStartButtonText | translate )"
                                        [textCls]="'large-btn-text-500 ws-normal text-center m-auto'"
                                        [height]="50"
                                        [width]="310"
                                        [cornerRadius]="16"
                                        [backgroundFillCls]="'transparent-background'"
                                        [hoverFillCls]="'xeroBackground'"
                                        [borderWidth]=2
                                        [borderColorCls]="'xeroBorder'"
                                        [hoverBorderColorCls]="'xeroBorder'"
                                        [textColorCls]="'b1color'"
                                        [hoverTextColorCls]="'white-color'"
                                        [leftImgCls]="'xeroLogo-small m-left-10'"
                                        (click)="!isUpgradeNeeded && xeroChosen()"
                                        data-testid="xeroSignUpBtn"
                                        [style.cursor]="isUpgradeNeeded ? '' : 'pointer'"
                                        [ignoreLeftSpace]="true">
                            </simple-btn>
                        </div>

                        <div [height]="30"></div>

                    </div>
                </ng-template>
            </div>
        </div>
    </div>

    <!-- Create plan with help example block -->
    <div #chooseTemplateBlock class="chooseTemplateBlock" style="display: none">

        <div style="text-align: center">
            <div class="cnt-column-centered">
                <div class="cnt-row" [style.align-items]="'center'">
                    <p class="chooseTemplateHeaderFont b1Color" [style.margin-right.px]="10" i18n>{{ 'CHOOSE_A_TEMPLATE' | translate }}</p>
                    <close-btn [testId]="'chooseTemplateCloseBtn'" (click)="onClose()"></close-btn>
                </div>
            </div>
            <p class="chooseTemplateFont b1Color" i18n>{{ 'TEMPLATES_ARE_PRE_BUILT' | translate }}</p>
        </div>

        <div [height]="17"></div>

        <!-- Set up template block -->
        <div class="setupBlockFlex">

            <div (click)="chooseTemplate(template.BikeshopBlank, $event)" class="templateBox">
                <infoPopUp [pFieldID]="'BikeshopTemplate'" class="info-popup" [logoText]="''" (infoOpened)="closeOtherInfoPanels($event)" [dCreator]="parent.getDialogCreator()"></infoPopUp>
                <div class="plan-template-logo bike-shop" style="margin-top: 17px"></div>
                <div [height]="10" class="pointer"></div>
                <span class="h3Font b1Color" i18n>{{ 'BIKE_SHOP' | translate }}</span>
            </div>

            <div (click)="chooseTemplate(template.CoffeeShop, $event)" class="templateBox">
                <infoPopUp [pFieldID]="'CoffeeshopTemplate'" class="info-popup" [logoText]="''" (infoOpened)="closeOtherInfoPanels($event)" [dCreator]="parent.getDialogCreator()"></infoPopUp>
                <div class="plan-template-logo coffee-shop" style="margin-top: 17px"></div>
                <div [height]="10" class="pointer"></div>
                <span class="h3Font b1Color" i18n>{{ 'COFFEE_SHOP' | translate }}</span>
            </div>

            <div (click)="chooseTemplate(template.Consulting, $event)" class="templateBox">
                <infoPopUp [pFieldID]="'ConsultingTemplate'" class="info-popup" [logoText]="''" (infoOpened)="closeOtherInfoPanels($event)" [dCreator]="parent.getDialogCreator()"></infoPopUp>
                <div class="plan-template-logo consulting" style="margin-top: 17px"></div>
                <div [height]="10" class="pointer"></div>
                <span class="h3Font b1Color" i18n>{{ 'CONSULTING' | translate }}</span>
            </div>

            <div (click)="chooseTemplate(template.Ecommerce, $event)" class="templateBox">
                <infoPopUp [pFieldID]="'E-commerceTemplate'" class="info-popup" [logoText]="''" (infoOpened)="closeOtherInfoPanels($event)" [dCreator]="parent.getDialogCreator()"></infoPopUp>
                <div class="plan-template-logo e-commerce" style="margin-top: 17px"></div>
                <div [height]="10" class="pointer"></div>
                <span class="h3Font b1Color" i18n>{{ 'E_COMMERCE' | translate }}</span>
            </div>

            <div (click)="chooseTemplate(template.FoodVan, $event)" class="templateBox">
                <infoPopUp [pFieldID]="'FoodVanTemplate'" class="info-popup" [logoText]="''" (infoOpened)="closeOtherInfoPanels($event)" [dCreator]="parent.getDialogCreator()"></infoPopUp>
                <div class="plan-template-logo food-van" style="margin-top: 17px"></div>
                <div [height]="10" class="pointer"></div>
                <span class="h3Font b1Color" i18n>{{ 'FOOD_VAN' | translate }}</span>
            </div>

            <div (click)="chooseTemplate(template.Gardening, $event)" class="templateBox">
                <infoPopUp [pFieldID]="'GardeningTemplate'" class="info-popup" [logoText]="''" (infoOpened)="closeOtherInfoPanels($event)" [dCreator]="parent.getDialogCreator()"></infoPopUp>
                <div class="plan-template-logo gardening" style="margin-top: 17px"></div>
                <div [height]="10" class="pointer"></div>
                <span class="h3Font b1Color" i18n>{{ 'GARDENING' | translate }}</span>
            </div>

            <div (click)="chooseTemplate(template.Manufacturing, $event)" class="templateBox">
                <infoPopUp [pFieldID]="'ManufacturingTemplate'" class="info-popup" [logoText]="''" (infoOpened)="closeOtherInfoPanels($event)" [dCreator]="parent.getDialogCreator()"></infoPopUp>
                <div class="plan-template-logo manufacturing" style="margin-top: 17px"></div>
                <div [height]="10" class="pointer"></div>
                <span class="h3Font b1Color" i18n>{{ 'MANUFACTURING' | translate }}</span>
            </div>

            <div (click)="chooseTemplate(template.Photography, $event)" class="templateBox">
                <infoPopUp [pFieldID]="'PhotographyTemplate'" class="info-popup" [logoText]="''" (infoOpened)="closeOtherInfoPanels($event)" [dCreator]="parent.getDialogCreator()"></infoPopUp>
                <div class="plan-template-logo photography" style="margin-top: 17px"></div>
                <div [height]="10" class="pointer"></div>
                <span class="h3Font b1Color" i18n>{{ 'PHOTOGRAPHY' | translate }}</span>
            </div>

            <div (click)="chooseTemplate(template.Restaurant, $event)" class="templateBox">
                <infoPopUp [pFieldID]="'RestaurantTemplate'" class="info-popup" [logoText]="''" (infoOpened)="closeOtherInfoPanels($event)" [dCreator]="parent.getDialogCreator()"></infoPopUp>
                <div class="plan-template-logo restaurant" style="margin-top: 17px"></div>
                <div [height]="10" class="pointer"></div>
                <span class="h3Font b1Color" i18n>{{ 'RESTAURANT' | translate }}</span>
            </div>

            <div (click)="chooseTemplate(template.Retail, $event)" class="templateBox">
                <infoPopUp [pFieldID]="'RetailTemplate'" class="info-popup" [logoText]="''" (infoOpened)="closeOtherInfoPanels($event)" [dCreator]="parent.getDialogCreator()"></infoPopUp>
                <div class="plan-template-logo retail" style="margin-top: 17px"></div>
                <div [height]="10" class="pointer"></div>
                <span class="h3Font b1Color" i18n>{{ 'RETAIL' | translate }}</span>
            </div>

            <div (click)="chooseTemplate(template.SAAS, $event)" class="templateBox">
                <infoPopUp [pFieldID]="'SAASTemplate'" class="info-popup" [logoText]="''" (infoOpened)="closeOtherInfoPanels($event)" [dCreator]="parent.getDialogCreator()"></infoPopUp>
                <div class="plan-template-logo saas" style="margin-top: 17px"></div>
                <div [height]="10" class="pointer"></div>
                <span class="h3Font b1Color" i18n>{{ 'SAAS' | translate }}</span>
            </div>
        </div>

        <!-- Footer template plan block -->
        <div class="standardOrEmptyBlock">
            <div style="text-align: center; margin-top: 24px">
                <p class="standardTemplateFont b1Color" i18n>
                    {{ 'DONOT_SEE_YOUR_INDUSTRY' | translate }}
                    <a (click)="chooseTemplate(template.StandardBusinessTemplate)" data-testid="businessTemplateBtn" class="underline o2Color" style="cursor: pointer">{{ 'STANDARD_BUSINESS_TEMPLATE' | translate }}</a>&nbsp;
                </p>
                <p class="blankTemplateFont b1Color" i18n>
                    {{ 'ALTERNATIVELY_START_FROM_SCRATCH' | translate }}&nbsp;
                    <a (click)="chooseTemplate(template.Blank)" data-testid="emptyTemplateBtn" class="underline o2Color" style="cursor: pointer">{{ 'BLANK_PLAN' | translate }}</a>&nbsp;{{ 'FOR_EXPERIENCED_USERS' | translate }}</p>
            </div>
        </div>
    </div>
</form>